import { createContext, useContext, useState, useCallback } from 'react';

/**
 * Contexto del "usuario actual".
 *
 * En esta iteración no hay sesión: simplemente guardamos el ID de paciente
 * que la persona ingresa en la pantalla de acceso. Lo persistimos en
 * localStorage para que sobreviva a recargas, pero NO implica autenticación.
 */
const UsuarioContext = createContext(null);

const STORAGE_KEY = 'sweetmedical.pacienteId';

export function UsuarioProvider({ children }) {
  const [pacienteId, setPacienteIdState] = useState(
    () => localStorage.getItem(STORAGE_KEY) || ''
  );

  const setPacienteId = useCallback((id) => {
    const valor = (id || '').trim();
    setPacienteIdState(valor);
    if (valor) localStorage.setItem(STORAGE_KEY, valor);
    else localStorage.removeItem(STORAGE_KEY);
  }, []);

  const limpiar = useCallback(() => setPacienteId(''), [setPacienteId]);

  return (
    <UsuarioContext.Provider value={{ pacienteId, setPacienteId, limpiar }}>
      {children}
    </UsuarioContext.Provider>
  );
}

export function useUsuario() {
  const ctx = useContext(UsuarioContext);
  if (!ctx) throw new Error('useUsuario debe usarse dentro de <UsuarioProvider>');
  return ctx;
}
